import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faBox,
  faFileAlt,
  faTruck,
  faDollarSign,
  faUsers,
  faShieldAlt,
  faChartBar,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const sections = [
  {
    title: "🌍 Product Listings",
    desc: "Browse or list agricultural products available for export and import with global standards.",
    icon: faBox,
    action: "View Catalog",
    dummyData: ["Wheat – Grade A", "Basmati Rice", "Organic Turmeric", "Cold-Pressed Oil"],
  },
  {
    title: "📑 Compliance & Documents",
    desc: "Track and upload required certificates, licenses, and customs documents for shipments.",
    icon: faFileAlt,
    action: "Upload Docs",
    dummyData: ["Phytosanitary Certificate.pdf", "FSSAI License.pdf", "Export Permit.docx"],
  },
  {
    title: "🚚 Shipments & Logistics",
    desc: "Manage transport options: Sea, Air, or Land. Track live shipment status with partners.",
    icon: faTruck,
    action: "Manage Shipments",
    dummyData: ["Container #MAEU12345 – In Transit", "Shipment ETA: 4 days", "Port: Nhava Sheva"],
  },
  {
    title: "💱 Pricing & Forex",
    desc: "Check global commodity prices, indicative freight costs, and currency conversions.",
    icon: faDollarSign,
    action: "Check Rates",
    dummyData: [
      "Basmati Rice – $1,200/ton",
      "USD/INR: ₹84.5",
      "Freight to Dubai: $45/container",
    ],
  },
  {
    title: "🤝 Trade Connect",
    desc: "Post product requirements or offers and connect with global buyers and sellers.",
    icon: faUsers,
    action: "Find Partners",
    dummyData: [
      "Buyer: GreenFarm UK (100 MT Wheat)",
      "Seller: AgriWorld India (Turmeric)",
      "Chat Room: Global Spice Trade",
    ],
  },
  {
    title: "🛡️ Risk & Quality",
    desc: "See alerts on quality standards, cold-chain needs, and restricted market access.",
    icon: faShieldAlt,
    action: "View Alerts",
    dummyData: [
      "Alert: Temperature deviation in Container #123",
      "Notice: EU import restriction update",
    ],
  },
  {
    title: "📊 My Dashboard",
    desc: "View your posted deals, compliance status, active shipments, and cost savings.",
    icon: faChartBar,
    action: "Open Dashboard",
    dummyData: [
      "Active Deals: 12",
      "Pending Compliance: 3",
      "Shipment Cost Saved: ₹1.2L",
    ],
  },
];

const AgriLinkExportImport = () => {
  const [activeSection, setActiveSection] = useState(null);

  return (
    <div>
      <section className="py-4 px-6 md:px-8 bg-black min-h-screen">
        {/* Hero Section */}
        <div className="text-center mb-4 border border-green-400 py-4">
          <h1 className="text-xl md:text-2xl font-bold text-yellow-200 flex items-center justify-center gap-3">
            <FontAwesomeIcon icon={faGlobe} className="w-8 h-8 text-yellow-200" />
            AgriLink Export–Import Hub
          </h1>
          <p className="mt-4 text-white mx-auto">
            Connecting Bharat’s farms to the world with smarter trade, logistics, and compliance tools.
          </p>
        </div>

        {/* Sections Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mx-auto">
          {sections.map((s, idx) => (
            <div
              key={idx}
              className="flex flex-col justify-between rounded-2xl shadow-lg hover:shadow-xl transition border border-green-400 bg-black"
            >
              <div className="p-6 flex flex-col h-full">
                <div className="flex items-center gap-3 mb-4">
                  {/* <FontAwesomeIcon icon={s.icon} className="w-7 h-7 text-green-600" /> */}
                  <h3 className="text-lg font-semibold text-yellow-200">{s.title}</h3>
                </div>
                <p className="text-white text-sm flex-grow">{s.desc}</p>
                <button
                  onClick={() => setActiveSection(activeSection === idx ? null : idx)}
                  className="mt-4 bg-green-700 hover:bg-green-800 text-white rounded-xl py-2 w-full transition"
                >
                  {activeSection === idx ? "Hide Info" : s.action}
                </button>

                {/* Dummy Data Panel */}
                {activeSection === idx && (
                  <div className="mt-4 bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-gray-700 animate-fade-in">
                    <div className="flex justify-between mb-2">
                      <span className="font-semibold text-green-800">
                        {s.title.split(" ")[0]} Snapshot
                      </span>
                      <FontAwesomeIcon
                        icon={faTimes}
                        className="text-red-500 cursor-pointer"
                        onClick={() => setActiveSection(null)}
                      />
                    </div>
                    <ul className="list-disc ml-5 space-y-1">
                      {s.dummyData.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border border-green-300 text-white py-10 px-4 sm:px-6 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">
            &copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-green-400 transition">
              About
            </Link>
            <Link to="/privacy-policy" className="text-white hover:text-green-400 transition">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="text-white hover:text-green-400 transition">
              Terms of Use
            </Link>
            <Link to="/contact-us" className="text-white hover:text-green-400 transition">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AgriLinkExportImport;
